import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import { LISTING_STATUS_LABEL } from '@/constants/listing.constants';
import type { ListingStatus } from '@/types/rental.types';

const ListingStatusPill: FC<{ status: ListingStatus }> = ({ status }) => {
  const meta = LISTING_STATUS_LABEL[status];
  return <Pill tone={meta.tone}>{meta.label}</Pill>;
};

export default ListingStatusPill;
